import { IOrderDelivery } from '../models/i-order';
import { ORDER_DELIVERY_METHODS } from '../constants/common.constants';

/**A NO_DELIVERY order carries no deliveryDate, deliveryType or deliveryTime,
 * and its price / priceWithoutVat are zero */
export function isNoDeliveryOrder(deliveryOrder?: IOrderDelivery): boolean {
  return Boolean(deliveryOrder) && deliveryOrder.type === ORDER_DELIVERY_METHODS.NO_DELIVERY;
}

/**Whether there is any delivery or pickup information worth rendering */
export function hasDeliveryDetails(deliveryOrder?: IOrderDelivery): boolean {
  return Boolean(deliveryOrder) && !isNoDeliveryOrder(deliveryOrder);
}
